import UniqueIdHelper from "../../helper/UniqueIdHelper";

export default class RequestBase {
    public action!: string;
    public attempt!: number;
    private readonly pollToken: string;

    constructor() {
        this.pollToken = UniqueIdHelper.getUniqueEventId();
    }

}
